import { render, staticRenderFns } from "./detailAction.vue?vue&type=template&id=16691217&scoped=true"
import script from "./detailAction.vue?vue&type=script&lang=js"
export * from "./detailAction.vue?vue&type=script&lang=js"
import style0 from "./detailAction.vue?vue&type=style&index=0&id=16691217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16691217",
  null
  
)

export default component.exports